<template>
    <v-container grid-list-lg grid-list-md>
        <v-form ref="form">
            <v-layout card column wrap>
                <v-layout row wrap>
                    <!-- Data e hora -->
                    <v-flex lg3 xs12>
                        <v-label>Data e hora da publicação</v-label>
                        <v-text-field :rules="[rules.required,rules.datetime,rules.dataHoraFutura]"
                                      flat
                                      mask="##/##/#### ##:##"
                                      maxlength="16" return-masked-value
                                      solo
                                      v-model="model.data_hora_publicacao"
                                      validate-on-blur>
                        </v-text-field>
                    </v-flex>
                    <!-- Tipo conteudo -->
                    <v-flex lg3 xs12>
                        <v-label>Tipo de conteúdo</v-label>
                        <m-select :items="items_tipo"
                                  item-text="text"
                                  item-value="id"
                                  :rules="[rules.required]"
                                  @change="validaImagem"
                                  placeholder="Tipo"
                                  v-model="model.tipo_conteudo"
                                  validate-on-blur>
                        </m-select>
                    </v-flex>
                    <!--Título-->
                    <v-flex lg6 xs12>
                        <v-label>Título</v-label>
                        <v-text-field :rules="[rules.required]"
                                      flat
                                      maxlength="100"
                                      solo
                                      v-input-filter="[filters.alphanumeric]"
                                      v-model="model.titulo"
                                      validate-on-blur>
                        </v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <!--Link-->
                    <v-flex lg12 v-if="['pdf', 'video'].includes(model.tipo_conteudo)" xs12>
                        <v-label>Link</v-label>
                        <v-text-field :rules="[rules.required, rules.url]"
                                      flat
                                      maxlength="200"
                                      solo
                                      v-model="model.link"
                                      validate-on-blur>
                        </v-text-field>
                    </v-flex>
                    <!--Imagem-->
                    <v-flex lg3 v-if="model.tipo_conteudo === 'imagem'" xs12>
                        <v-label>Imagem:</v-label>
                        <br/>
                        <v-btn @click="$refs.inputUpload.click()" color="primary" outline round>
                            Escolher imagem
                            <v-icon dark right>cloud_upload</v-icon>
                        </v-btn>
                        <input @change="encodeImageFileAsURL" accept="image/*" id="inputFileToLoad" name="imagem"
                               ref="inputUpload"
                               type="file" v-show="false">
                    </v-flex>
                    <!--Preview-->
                    <div v-if="model.tipo_conteudo === 'imagem' && imgSrc !== ''" xs12 style="position: relative">
                        <img alt="Imagem do Comunicado" :src="imgSrc"
                             style="width: 300px; object-fit: contain; transition: 0.2s; cursor: pointer;"/>
                        <v-btn icon color="red" @click="this.removerImg" class="btn-remover-img">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </div>
                </v-layout>
                <v-layout row wrap>
                    <!--Texto-->
                    <v-flex xs12>
                        <v-label>Texto</v-label>
                        <v-textarea :rules="[rules.required]" counter flat
                                    maxlength="300" solo v-model="model.texto" validate-on-blur>
                        </v-textarea>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex mt-4 xs12>
                        <v-label>Quem irá visualizar?*</v-label>
                        <v-divider></v-divider>
                        <v-radio-group v-model="model.enviar_para_todos" :mandatory="false">
                            <v-radio label="Enviar comunicado para todos" :value="true"></v-radio>
                            <v-radio label="Enviar apenas para usuários selecionados na última hierarquia"
                                     :value="false"></v-radio>
                        </v-radio-group>
                    </v-flex>
                </v-layout>
                <v-layout grid-list-md row wrap>
                    <!--Diretores-->
                    <v-flex lg3 xs12>
                        <v-flex class="hierarquia">
                            <v-flex mb-2 ml-2><b>Diretores</b></v-flex>
                            <ul>
                                <li :key="diretor.id_diretor" v-for="diretor in hierarquias">
                                    <v-checkbox :label="diretor.hierarquia.usuario.nome" :value="diretor.checked"
                                                class="ma-0 pa-0"
                                                hide-details
                                                v-model="diretor.checked"
                                                :disabled="model.enviar_para_todos"/>
                                </li>
                            </ul>
                        </v-flex>
                        <v-layout>
                            <v-btn class="flex" style="font-size: 10px" text small color="primary" @click="checkDiretoresAll">Marcar todos</v-btn>
                            <v-btn class="flex" style="font-size: 10px" text small @click="unCheckDiretoresAll">Desmarcar todos</v-btn>
                        </v-layout>
                    </v-flex>
                    <!--Regionais-->
                    <v-flex lg3 xs12>
                        <v-flex class="hierarquia">
                            <v-flex mb-2 ml-2><b>Regionais</b></v-flex>
                            <div :key="diretor.id_diretor" v-for="diretor in hierarquias">
                                <ul v-if="diretor.checked">
                                    <li :key="regional.id_regional" v-for="regional in diretor.regionais">
                                        <v-checkbox :label="regional.hierarquia.usuario.nome || 'Vazio'"
                                                    :value="regional.checked"
                                                    class="ma-0 pa-0"
                                                    hide-details
                                                    v-model="regional.checked"
                                                    :disabled="model.enviar_para_todos"/>
                                    </li>
                                </ul>
                            </div>
                        </v-flex>
                        <v-layout>
                            <v-btn class="flex" style="font-size: 10px" text small color="primary" @click="checkRegionaisAll">Marcar todos</v-btn>
                            <v-btn class="flex" style="font-size: 10px" text small @click="unCheckRegionaisAll">Desmarcar todos</v-btn>
                        </v-layout>
                    </v-flex>
                    <!--Gerentes-->
                    <v-flex lg3 xs12>
                        <v-flex class="hierarquia">
                            <v-flex mb-2 ml-2><b>Gerentes</b></v-flex>
                            <div :key="diretor.id_diretor" v-for="diretor in hierarquias">
                                <ul v-if="diretor.checked">
                                    <div :key="regional.id_regional" v-for="regional in diretor.regionais">
                                        <ul v-if="regional.checked">
                                            <li :key="gerente.id_gerente" v-for="gerente in regional.gerentes">
                                                <v-checkbox :label="gerente.hierarquia.usuario.nome"
                                                            :value="gerente.checked"
                                                            class="ma-0 pa-0"
                                                            hide-details
                                                            v-model="gerente.checked"
                                                            :disabled="model.enviar_para_todos"/>
                                            </li>
                                        </ul>
                                    </div>
                                </ul>
                            </div>
                        </v-flex>
                        <v-layout>
                            <v-btn class="flex" style="font-size: 10px" text small color="primary" @click="checkGerenteAll">Marcar todos</v-btn>
                            <v-btn class="flex" style="font-size: 10px" text small @click="unCheckGerenteAll">Desmarcar todos</v-btn>
                        </v-layout>
                    </v-flex>
                    <!--Supervisor-->
                    <v-flex lg3 xs12>
                        <v-flex class="hierarquia">
                            <v-flex mb-2 ml-2><b>Supervisores</b></v-flex>
                            <div :key="diretor.id_diretor" v-for="diretor in hierarquias">
                                <ul v-if="diretor.checked">
                                    <div :key="regional.id_regional" v-for="regional in diretor.regionais">
                                        <div v-if="regional.checked">
                                            <div :key="gerente.id_gerente" v-for="gerente in regional.gerentes">
                                                <ul v-if="gerente.checked">
                                                    <li :key="supervisor.id_supervisor"
                                                        v-for="supervisor in gerente.supervisor">
                                                        <v-checkbox :label="supervisor.hierarquia.usuario.nome"
                                                                    :value="supervisor.checked"
                                                                    class="ma-0 pa-0"
                                                                    hide-details
                                                                    v-model="supervisor.checked"
                                                                    :disabled="model.enviar_para_todos"/>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </ul>
                            </div>
                        </v-flex>
                        <v-layout>
                            <v-btn class="flex" style="font-size: 10px" text small color="primary" @click="checkSupervisorAll">Marcar todos</v-btn>
                            <v-btn class="flex" style="font-size: 10px" text small @click="unCheckSupervisorAll">Desmarcar todos</v-btn>
                        </v-layout>
                    </v-flex>
                    <!--Vendedores-->
                    <v-flex lg3 xs12>
                        <v-flex class="hierarquia">
                            <v-flex mb-2 ml-2><b>Vendedores</b></v-flex>
                            <div :key="diretor.id_diretor" v-for="diretor in hierarquias">
                                <ul v-if="diretor.checked">
                                    <div :key="regional.id_regional" v-for="regional in diretor.regionais">
                                        <div v-if="regional.checked">
                                            <div :key="gerente.id_gerente" v-for="gerente in regional.gerentes">
                                                <ul v-if="gerente.checked">
                                                    <div :key="supervisor.id_gerente"
                                                         v-for="supervisor in gerente.supervisor">
                                                        <ul v-if="supervisor.checked">
                                                            <li :key="vendedor.id_vendedor"
                                                                v-for="vendedor in supervisor.vendedores">
                                                                <v-checkbox :label="vendedor.hierarquia.usuario.nome"
                                                                            :value="vendedor.checked"
                                                                            class="ma-0 pa-0"
                                                                            hide-details
                                                                            v-model="vendedor.checked"
                                                                            :disabled="model.enviar_para_todos"/>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </ul>
                            </div>
                        </v-flex>
                        <v-layout>
                            <v-btn class="flex" style="font-size: 10px" text small color="primary" @click="checkVendedorAll">Marcar todos</v-btn>
                            <v-btn class="flex" style="font-size: 10px" text small @click="unCheckVendedorAll">Desmarcar todos</v-btn>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <br>
                <p>*Apenas os usuários da última hierarquia selecionados que irão receber o comunicado.</p>
                <v-layout mt-3>
                    <!--Salvar-->
                    <v-flex xs2>
                        <v-btn @click="this.salvar" class="btn-default primary">Salvar</v-btn>
                    </v-flex>
                </v-layout>
            </v-layout>
        </v-form>
    </v-container>
</template>
<script>
import Rules from '../plugins/validation'
import Filters from '../plugins/filters'
import { mapState } from 'vuex'
import { alert, error, sleep } from '../plugins/helpers'
import moment from 'moment'

const listagem = 'comunicados'

export default {
  name: 'cadastro_comunicado',
  edicao: false,
  file: '',
  data: () => ({
    edicao: false,
    imgSrc: '',
    isActive: '',
    imgWidth: 0,
    imgHeight: 0,
    imgSizeBytes: 0,
    model: {
      data_hora_publicacao: '',
      tipo_conteudo: 'texto',
      titulo: '',
      link: '',
      imagem: '',
      existeImg: false,
      filename: '',
      extensao: '',
      texto: '',
      id_unidade_negocio: '',
      enviar_para_todos: false,
      hierarquias: []
    },
    items_tipo: [
      { text: 'texto', id: 'texto' },
      { text: 'imagem', id: 'imagem' },
      { text: 'pdf', id: 'pdf' },
      { text: 'vídeo', id: 'video' }
    ],
    hierarquias: [
      {
        checked: false,
        hierarquia: {
          usuario: {
            nome: ''
          }
        },
        regionais: [
          {
            checked: false,
            hierarquia: {
              usuario: {
                nome: ''
              }
            },
            gerentes: [
              {
                checked: false,
                hierarquia: {
                  usuario: {
                    nome: ''
                  }
                },
                supervisor: [
                  {
                    checked: false,
                    hierarquia: {
                      usuario: {
                        nome: ''
                      }
                    },
                    vendedores: [
                      {
                        checked: false,
                        hierarquia: {
                          usuario: {
                            nome: ''
                          }
                        }
                      }]
                  }]
              }]
          }]
      }]
  }),
  computed: {
    rules: () => Rules,
    filters: () => Filters,
    ...mapState(['id_unidade_negocio'])
  },
  methods: {
    checkDiretoresAll () {
      this.hierarquias.forEach((diretor) => {
        this.$set(diretor, 'checked', true)
      })
    },
    unCheckDiretoresAll () {
      this.hierarquias.forEach((diretor) => {
        this.$set(diretor, 'checked', false)
      })
    },
    checkRegionaisAll () {
      this.hierarquias.forEach((diretor) => {
        diretor.regionais.forEach((regional) => {
          this.$set(regional, 'checked', true)
        })
      })
    },
    unCheckRegionaisAll () {
      this.hierarquias.forEach((diretor) => {
        diretor.regionais.forEach((regional) => {
          this.$set(regional, 'checked', false)
        })
      })
    },
    checkGerenteAll () {
      this.hierarquias.forEach((diretor) => {
        diretor.regionais.forEach(regional => {
          regional.gerentes.forEach(r => {
            this.$set(r, 'checked', true)
          })
        })
      })
    },
    unCheckGerenteAll () {
      this.hierarquias.forEach((diretor) => {
        diretor.regionais.forEach(regional => {
          regional.gerentes.forEach(r => {
            this.$set(r, 'checked', false)
          })
        })
      })
    },
    checkSupervisorAll () {
      this.hierarquias.forEach((diretor) => {
        diretor.regionais.forEach(regional => {
          regional.gerentes.forEach(gerente => {
            gerente.supervisor.forEach(supervisor => {
              this.$set(supervisor, 'checked', true)
            })
          })
        })
      })
    },
    unCheckSupervisorAll () {
      this.hierarquias.forEach((diretor) => {
        diretor.regionais.forEach(regional => {
          regional.gerentes.forEach(gerente => {
            gerente.supervisor.forEach(supervisor => {
              this.$set(supervisor, 'checked', false)
            })
          })
        })
      })
    },
    checkVendedorAll () {
      this.hierarquias.forEach((diretor) => {
        diretor.regionais.forEach(regional => {
          regional.gerentes.forEach(gerente => {
            gerente.supervisor.forEach(supervisor => {
              supervisor.vendedores.forEach(vendedor => {
                this.$set(vendedor, 'checked', true)
              })
            })
          })
        })
      })
    },
    unCheckVendedorAll () {
      this.hierarquias.forEach((diretor) => {
        diretor.regionais.forEach(regional => {
          regional.gerentes.forEach(gerente => {
            gerente.supervisor.forEach(supervisor => {
              supervisor.vendedores.forEach(vendedor => {
                this.$set(vendedor, 'checked', false)
              })
            })
          })
        })
      })
    },
    loadImg (blob) {
      let urlCreator = window.URL || window.webkitURL
      this.imgSrc = urlCreator.createObjectURL(blob)

      this.model.filename = this.model.imagem
      this.model.existeImg = true
    },
    encodeImageFileAsURL () {
      let vm = this
      vm.model.existeImg = false
      let filesSelected = document.getElementById('inputFileToLoad').files
      if (filesSelected.length > 0) {
        let fileToLoad = filesSelected[0]

        vm.imgSizeBytes = fileToLoad.size

        let reader = new FileReader()

        let extension = filesSelected[0].name.split('.').pop().toLowerCase()
        let filename = filesSelected[0].name

        reader.onload = function (theFile) {
          let image = new Image()
          image.src = theFile.target.result

          image.onload = function () {
            vm.imgWidth = image.width
            vm.imgHeight = image.height
          }

          vm.imgSrc = theFile.target.result// <--- data: base64
          vm.model.imagem = filename
          vm.model.filename = filename
          vm.model.extensao = extension
          vm.model.existeImg = true
          vm.file = vm.$refs.inputUpload.files[0]
        }
        reader.readAsDataURL(fileToLoad)
      }
    },
    modelComunicadoHierarquia () {
      this.model.hierarquias = []
      let maior = 0

      this.hierarquias.forEach(diretor => {
        this.model.hierarquias.push({ id: diretor.id_hierarquia, nivel: 1 })
        maior = maior >= 1 ? maior : 1
        diretor.regionais.forEach(regional => {
          if (regional.checked) {
            maior = maior >= 2 ? maior : 2
            this.model.hierarquias.push({ id: regional.id_hierarquia, nivel: 2 })
            regional.gerentes.forEach(gerente => {
              if (gerente.checked) {
                maior = maior >= 3 ? maior : 3
                this.model.hierarquias.push({ id: gerente.id_hierarquia, nivel: 3 })
                gerente.supervisor.forEach(supervisor => {
                  if (supervisor.checked) {
                    maior = maior >= 4 ? maior : 4
                    this.model.hierarquias.push({ id: supervisor.id_hierarquia, nivel: 4 })
                    supervisor.vendedores.forEach(vendedores => {
                      if (vendedores.checked) {
                        maior = maior >= 5 ? maior : 5
                        this.model.hierarquias.push({ id: vendedores.id_hierarquia, nivel: 5 })
                      }
                    })
                  }
                })
              }
            })
          }
        })
      })
      this._.remove(this.model.hierarquias, (v) => {
        return v.nivel < maior
      })
    },
    validaImagem () {
      if (!['imagem'].includes(this.model.tipo_conteudo)) {
        this.model.existeImg = false
        this.model.imagem = ''
        this.model.extensao = ''
        this.imgSrc = ''
        this.filename = ''
      }
    },
    salvar () {
      if (this.model.tipo_conteudo === 'imagem' && this.imgSizeBytes > 5000000) {
        error(null, 'Imagem não pode ultrapassar 5mb de tamanho')
        return
      }

      if (this.model.tipo_conteudo === 'imagem' && this.imgWidth > 1024) {
        error(null, 'Imagem não pode ser maior do que 1024px de largura.')
        return
      }

      if (this.model.tipo_conteudo === 'imagem' && this.imgHeight > 1024) {
        error(null, 'Imagem não pode ser maior do que 1024px de altura.')
        return
      }

      const form = this.$refs.form

      let diretor_selecionado = false
      this.hierarquias.forEach((diretor) => {
        if (!diretor_selecionado) {
          diretor_selecionado = diretor.checked
        }
      })
      if (!diretor_selecionado && !this.model.enviar_para_todos) {
        error(null, 'Ao menos uma hierarquia deve estar marcada.')
        return
      }

      if (this.model.tipo_conteudo === 'imagem' && !this.model.imagem) {
        error(null, 'Para o tipo de conteúdo IMAGEM, é necessário selecionar uma imagem.')
        return
      }

      this.modelComunicadoHierarquia()

      if (form.validate()) {
        let req

        let dadosForm = new FormData()

        if (this.model.existeImg) {
          dadosForm.append('img_file', this.$refs.inputUpload.files[0])
        }

        dadosForm.append('dados', JSON.stringify(this.model))

        if (this.edicao) {
          req = this.$http.post(`/admin/comunicados/${this.model.id_comunicado}`, dadosForm)
        } else {
          req = this.$http.post('/admin/comunicados', dadosForm)
        }

        req.then(() => {
          alert({
            text: `Comunicado ${this.edicao ? 'alterado' : 'cadastrado'} com sucesso!`,
            buttons: {
              'OK': () => {
                this.$router.push({ name: listagem })
              }
            }
          })
        }).catch(err => {
          error(err, 'Não foi possível salvar as informações.')
        })
      } else {
        form.resetValidation()
        sleep(100).then(() => form.validate())
      }
    },
    init () {
      this.model.id_unidade_negocio = this.id_unidade_negocio

      if ('id_comunicado' in this.$route.params) {
        const id_comunicado = this.$route.params['id_comunicado']
        this.$http.get(`/admin/comunicados/${id_comunicado}`).then((r) => {
          this.edicao = true
          this.model = r.data

          if (r.data['data_hora_publicacao']) {
            this.model.data_hora_publicacao = moment(r.data['data_hora_publicacao']).format('DD/MM/YYYY HH:mm')
          }

          if (this.model.imagem !== '') {
            this.$http.get(`/admin/comunicados/imagem/${this.model.imagem}`, {
              responseType: 'blob'
            }).then((img) => {
              this.loadImg(img.data)
            }).catch(err => {
              error(err, 'Não foi possível recuperar as informações')
            })
          }

          // percorre hierarquias e vai marcando
          this.model.hierarquias.forEach((hierarquia) => {
            let naoEncontrou = true
            this.hierarquias.forEach((diretor) => {
              if (hierarquia.id_hierarquia === diretor.id_hierarquia) {
                diretor.checked = true
                naoEncontrou = false
              } else {
                diretor.regionais.forEach((regional) => {
                  if (hierarquia.id_hierarquia === regional.id_hierarquia) {
                    diretor.checked = true
                    regional.checked = true
                    naoEncontrou = false
                  } else {
                    regional.gerentes.forEach((gerente) => {
                      if (hierarquia.id_hierarquia === gerente.id_hierarquia) {
                        diretor.checked = true
                        regional.checked = true
                        gerente.checked = true
                        naoEncontrou = false
                      } else {
                        gerente.supervisor.forEach((supervisor) => {
                          if (hierarquia.id_hierarquia === supervisor.id_hierarquia) {
                            diretor.checked = true
                            regional.checked = true
                            gerente.checked = true
                            supervisor.checked = true
                            naoEncontrou = false
                          } else {
                            supervisor.vendedores.forEach((vendedor) => {
                              if (hierarquia.id_hierarquia === vendedor.id_hierarquia) {
                                diretor.checked = true
                                regional.checked = true
                                gerente.checked = true
                                supervisor.checked = true
                                vendedor.checked = true
                                naoEncontrou = false
                              }
                            })
                          }
                        })
                      }
                    })
                  }
                })
              }
            })
            if (naoEncontrou) {
              error(null, `Hierarquia ${hierarquia.id_hierarquia} não encontrada`)
            }
          })
        }).catch(err => {
          error(err, 'Não foi possível recuperar as informações!')
        })
      }
    },
    initHierarquia () {
      this.model.id_unidade_negocio = this.id_unidade_negocio
      this.$http.get(`/admin/comunicados/unidadenegocio/${this.model.id_unidade_negocio}`).then((r) => {
        if (r.data.length === 0) {
          error(null, 'Não foi possível recuperar as informações da hierarquia!')
        } else {
          this.hierarquias = r.data
        }

        this.init()
      }).catch(err => {
        error(err, 'Não foi possível recuperar as informações!')
      })
    },
    removerImg () {
      this.imgSrc = ''
      this.imgWidth = 0
      this.imgHeight = 0
      this.imgSizeBytes = 0
      this.model = {
        ...this.model,
        imagem: '',
        existeImg: false,
        filename: '',
        extensao: ''
      }
      this.$refs.inputUpload.value = ''
    }
  },
  beforeMount () {
    this.initHierarquia()
  }
}
</script>
<style scoped>
ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.hierarquia ul li {
    margin-bottom: 15px;
    /* necessário porque se o checkbox ficar colado no outro,
       o clique pode pegar no mais próximo, pois a
       área de clique é muito grande no vuetify */
}

.hierarquia {
    border: 1px solid #d2d2d2;
    overflow-y: auto;
    height: 200px;
    border-radius: 9px;
    padding: 10px;
    font-size: 14px;
}

.btn-remover-img {
    position: absolute !important;
    top: 0;
    right: 0;
}

.btn-remover-img .v-icon {
    color: #FFF !important;
}
</style>
